import { render, staticRenderFns } from "./editArticle.vue?vue&type=template&id=78c0648e&scoped=true&"
import script from "./editArticle.vue?vue&type=script&lang=js&"
export * from "./editArticle.vue?vue&type=script&lang=js&"
import style0 from "./editArticle.vue?vue&type=style&index=0&id=78c0648e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0648e",
  null
  
)

export default component.exports